import _ from 'lodash';
import Vue from 'vue';
import Dialog from './MessageBox.vue';
import { isVNode } from 'element-ui/src/utils/vdom';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
const MessageBoxConstructor = Vue.extend(Dialog);
const close = (instance) => {
    if (instance && instance.$destroy) {
        instance.$destroy();
    }
};
export function messageBox(option) {
    const i18n = injectService(i18nSymbol);
    const instance = new MessageBoxConstructor({
        el: document.createElement('div'),
        // @ts-ignore
        i18n,
    });
    if (isVNode(option.message)) {
        instance.$slots.default = option.message;
        option.message = undefined;
    }
    if (isVNode(option.title)) {
        instance.$slots.title = option.title;
        option.title = undefined;
    }
    if (isVNode(option.footer)) {
        instance.$slots.footer = option.footer;
        option.footer = undefined;
    }
    _.assign(instance, option || {});
    document.body.appendChild(instance.$el);
    return { instance, close: () => close(instance) };
}
